
import React from 'react'
import { SvgIcon, SvgIconProps } from '@mui/material'

const arrowDownSvg = (
    <svg width="12" height="15" viewBox="0 0 12 15" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M6 0V13" stroke="currentColor" />
        <path d="M11.5 8L6 13.5L0.5 8" stroke="currentColor" />
    </svg>
)

const ArrowDown: React.FC<SvgIconProps> = (props) => (
    <SvgIcon {...props}>
        {arrowDownSvg}
    </SvgIcon>
)

export default ArrowDown